enum ClientSortingOptions {
  Ascending = 'asc',
  Descending = 'desc',
  Name = 'name',
  DisplayName = 'displayName',
  Administrator = 'administrator',
  Status = 'status'
}

enum UserSortingOptions {
  Ascending = 'asc',
  Descending = 'desc',
  Name = 'lastName',
  UserType = 'role',
  Email = 'email',
  Department = 'department',
  Status = 'status'
}

enum ClientUserSortingOptions {
  Ascending = 'asc',
  Descending = 'desc',
  Name = 'lastName',
  UserType = 'role',
  Email = 'email',
  Department = 'department',
  Status = 'status'
}

enum DashboardSortingOptions {
  Ascending = 'asc',
  Descending = 'desc',
  Name = 'name',
  Description = 'description',
  Tags = 'assignedTags',
  ReportId = 'reportId',
  Status = 'status'
}

export { ClientSortingOptions, UserSortingOptions, ClientUserSortingOptions, DashboardSortingOptions };
